<mat-card appearance="outlined" *ngIf="error" class="app-error">
  <mat-card-header>
    <div mat-card-avatar class="bg-warn">
      <mat-icon>error</mat-icon>
    </div>
    <mat-card-title>{{ error.key | translate }}</mat-card-title>
    <mat-card-subtitle>{{ error.message | translate }}</mat-card-subtitle>
  </mat-card-header>
</mat-card>
